import { render, staticRenderFns } from "./operatorInfo.vue?vue&type=template&id=54fb20b4&scoped=true&"
import script from "./operatorInfo.vue?vue&type=script&lang=js&"
export * from "./operatorInfo.vue?vue&type=script&lang=js&"
import style0 from "./operatorInfo.vue?vue&type=style&index=0&id=54fb20b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb20b4",
  null
  
)

export default component.exports